import { memo, useCallback, useEffect, useRef } from 'react';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { Element, Title } from 'src/components';
import { IContent } from 'src/interface';
import { isLargeFontSize } from 'src/selectors/content';
import { ContentSapo } from 'src/modules/content/components/shared/ContentSapo';
import { AudioSpeech, ContentBody, ContentMeta } from '../..';
import { ContentTypeIcon } from 'src/modules/content/components/shared/ContentTypeIcon';
import { AdBanner } from 'src/modules/shared/components/ad';
import styles from './style.module.scss';

const ContentAction = dynamic(() => import('../ContentAction'), {
    ssr: false,
});

interface IProps extends IContent {
    description: string;
    originalUrl?: string;
    bodys: any[];
    speechs: any[];
    showMoreButton?: boolean;
    isFetching?: boolean;
    isOpenContent?: boolean;
    adBottomContent?: any[];
    embedUrl?: string;
}

export default memo(function ContentMain(props: IProps) {
    const isLargeFont = useSelector(isLargeFontSize);
    const ref = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
        if (isLargeFont) {
            ref.current?.classList.add(styles['large-font']);
        } else {
            ref.current?.classList.remove(styles['large-font']);
        }
    }, [isLargeFont]);

    const renderAdsBottom = useCallback(() => {
        if (props.adBottomContent) {
            return props.adBottomContent?.map((id: string) => {
                return <AdBanner elId={id} key={id} />;
            });
        }
        return null;
    }, []);

    return (
        <Element domRef={ref} className={cn(styles['content-main'])}>
            <Title renderAs="h1">
                {props.title}{' '}
                <ContentTypeIcon contentTypes={props.contentTypes} />
            </Title>
            <ContentMeta content={props} />
            <ContentAction
                content={props}
                showMoreButton={props.showMoreButton}
            />
            <ContentSapo description={props.description} />
            {props.speechs?.length && <AudioSpeech speechs={props.speechs} />}
            <ContentBody
                isFetching={props.isFetching}
                isOpenContent={props.isOpenContent}
                publisherId={props.publisher?.id}
                {...props}
            />
            {renderAdsBottom()}
        </Element>
    );
});
